export default __webpack_public_path__ + "static/media/64t.8c5b5b7b.jpg";